import { Reward, RewardTitle } from '../../../reward/reward';
import { ExceptionsDTO } from '../../exceptions-dto/exceptions-dto';
import { ProductDTO } from '../product-dto/product-dto';

/**
 * Reward Response DTO used to interact with backend
 */
export class RewardResponseDTO implements Reward {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public cost: number,
    public imgSource: string | null,
    public discount: number,
    public rewardType: string,
    public businessLevelIds: number[],
    public familiesIds: number[],
    public rewardTitles: RewardTitle[],
    public startDate: Date,
    public endDate: Date | null,
    public redemptionLimit: number,
    public extensionPeriod: number,
    public vipOnly: boolean,
    public relatedWithProduct: boolean,
    public rewardCode: string,
    public id: number,
    public name: string,
    public enabled: boolean,
    public rewardExceptions: ExceptionsDTO[],
    public product: ProductDTO
  ) {}

  /**
   * Returns localized name based on the language in reward title
   @param {RewardTitle[]} rewardTitles
   @param {string} language
   @return {string}
  */
  public static getLocalizedName(
    rewardTitles: RewardTitle[],
    language: string
  ) {
    return rewardTitles.find((t) => t.language === language)?.name ?? '';
  }

  /**
   * Return families ids
   @param {any} familyMap
   @param {number[]} businessLevelIds
   @return {number[]} The filtered ids
   */
  public static getFamilyIds(
    familyMap: any,
    businessLevelIds: number[]
  ): number[] {
    const familiesSet: Set<number> = new Set(
      businessLevelIds
        .map((id) => familyMap[id])
        .filter((id): id is number => id !== undefined)
    );
    return [...familiesSet];
  }
}
